import React from 'react';
import { FIELD_NAME } from '../../../constants/form-constants';
import { TextInputExtended } from './core/text-input-extended';

interface Props {
	label?: string;
	required?: boolean;
}

const regExp =
	/^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

export function EmailInput(props: Props) {
	return (
		<TextInputExtended
			{...props}
			label={props.label || 'Email'}
			name={FIELD_NAME.EMAIL}
			validate={(value) => regExp.test(value)}
			errorMessage="Email incorrecto"
		/>
	);
}
